import { Action, Selector, State, StateContext } from '@ngxs/store';
import { StopAllDeviceTests, ToggleDeviceTestForOutputDevice, ToggleDeviceTestForRingingDevice, ToggleMuteMicrophoneAction } from './audio-settings.actions';
import { Injectable } from '@angular/core';

export interface SoundSettingsStateModel {
   isTestSoundForRingingDeviceActive: boolean;
   isTestSoundForOutputDeviceActive: boolean;
   isMicrophoneMuted: boolean;
}

// The AudioDevice settings are stored in the localStorage of the browser!
// See local-storage-settings.state.ts
@State<SoundSettingsStateModel>({
   name: 'soundSettings',
   defaults: {
      isTestSoundForOutputDeviceActive: false,
      isTestSoundForRingingDeviceActive: false,
      isMicrophoneMuted: false,
   },
})
@Injectable()
export class AudioSettingsState {
   @Selector([AudioSettingsState])
   public static isTestActiveForOutputDevice(state: SoundSettingsStateModel) {
      return state.isTestSoundForOutputDeviceActive;
   }

   @Selector([AudioSettingsState])
   public static isTestActiveForRingingDevice(state: SoundSettingsStateModel) {
      return state.isTestSoundForRingingDeviceActive;
   }

   @Selector([AudioSettingsState])
   public static isMicrophoneMuted(state: SoundSettingsStateModel): boolean {
      return state.isMicrophoneMuted;
   }

   @Action(ToggleDeviceTestForRingingDevice)
   public toggleDeviceTestForRingingDevice(ctx: StateContext<SoundSettingsStateModel>, action: ToggleDeviceTestForRingingDevice) {
      const state = ctx.getState();
      ctx.patchState({
         isTestSoundForRingingDeviceActive: !state.isTestSoundForRingingDeviceActive,
         isTestSoundForOutputDeviceActive: false,
      });
   }

   @Action(ToggleDeviceTestForOutputDevice)
   public toggleDeviceTestForOutputDevice(ctx: StateContext<SoundSettingsStateModel>, action: ToggleDeviceTestForOutputDevice) {
      const state = ctx.getState();
      ctx.patchState({
         isTestSoundForOutputDeviceActive: !state.isTestSoundForOutputDeviceActive,
         isTestSoundForRingingDeviceActive: false,
      });
   }

   @Action(StopAllDeviceTests)
   public stopAllDeviceTests(ctx: StateContext<SoundSettingsStateModel>, action: StopAllDeviceTests) {
      ctx.patchState({
         isTestSoundForOutputDeviceActive: false,
         isTestSoundForRingingDeviceActive: false,
      });
   }

   @Action(ToggleMuteMicrophoneAction)
   public ToggleMuteMicrophoneAction(ctx: StateContext<SoundSettingsStateModel>, action: ToggleMuteMicrophoneAction) {
      const state = ctx.getState();
      ctx.patchState({
         isMicrophoneMuted: !state.isMicrophoneMuted,
      });
   }
}
